<template>
    <el-card class="main-card">
        <template #header>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/purchase/requisition' }">采购申请</el-breadcrumb-item>
                <el-breadcrumb-item>{{ isEdit ? '编辑申请单' : isView ? '查看申请单' : '新增申请单' }}</el-breadcrumb-item>
            </el-breadcrumb>
        </template>

        <el-tabs v-model="activeTab" type="border-card">
            <!-- 基本信息 Tab -->
            <el-tab-pane label="基本信息" name="basic">
                <el-form :model="forms" :rules="rules" ref="forms" label-width="120px">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="申请单号" prop="billCode">
                                <el-input v-model="forms.billCode" :disabled="true || isEdit || isView"
                                    style="max-width: 220px;"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="单据类型" prop="billType" style="width:350px">
                                <el-select v-model="forms.billType" placeholder="请选择" :disabled="isView">
                                    <el-option label="常规采购" value="常规采购"></el-option>
                                    <el-option label="紧急采购" value="紧急采购"></el-option>
                                    <el-option label="计划采购" value="计划采购"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="制单日期" prop="billDate">
                                <el-date-picker v-model="forms.billDate" type="date" :disabled="isView"
                                    style="width:220px"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="所属公司" prop="companyID">
                                <el-tree-select ref="companys" v-model="forms.companyID" :data="companys"
                                    @change="companyChange();" check-strictly
                                    :render-after-expand="false" style="width: 280px;" />
                            </el-form-item>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="申请部门" prop="departmentID">
                                <el-tree-select ref="departments" v-model="forms.departmentID" :data="departments"
                                    clearable check-strictly :render-after-expand="false" style="width:220px" />
                            </el-form-item>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="申请人" prop="applicantName">
                                <el-input v-model="forms.applicantName" :disabled="isView"
                                    style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="需求日期" prop="requirementDate">
                                <el-date-picker v-model="forms.requirementDate" type="date" :disabled="isView"
                                    style="width:220px"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="外部编号" prop="externalNo">
                                <el-input v-model="forms.externalNo" :disabled="isView" style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="建议供应商" prop="suggestSupplierCode">
                                <el-select v-model="forms.suggestSupplierCode" filterable clearable placeholder="请选择供应商"
                                    :disabled="isView" style="width:220px" @change="(value) => {
                                        const selected = suppliers.find(s => s.supplierCode === value);
                                        forms.suggestSupplierName = selected ? selected.supplierName : '';
                                    }">
                                    <el-option v-for="s in suppliers" :key="s.supplierCode"
                                        :label="s.supplierName || s.text" :value="s.supplierCode"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :xs="24">
                            <el-form-item label="备注" prop="remark">
                                <el-input v-model="forms.remark" type="textarea" :rows="2" :disabled="isView"
                                    style="width:95%"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-tab-pane>

            <el-tab-pane label="附件" name="attachment">
                <div class="attachments-pane">
                    <el-alert
                        type="info"
                        show-icon
                        title="附件通过申请单号关联，请确保已生成申请单号后再上传"
                        class="attachments-alert"
                    />
                    <el-upload
                        class="attachments-uploader"
                        :action="uploadAction"
                        list-type="picture-card"
                        :file-list="fileList"
                        :on-success="handleAttachmentUploadSuccess"
                        :before-upload="handleAttachmentBeforeUpload"
                        :on-preview="handleAttachmentPreview"
                        :disabled="isView"
                        accept="*/*"
                    >
                        <el-icon>
                            <Plus />
                        </el-icon>
                        <template #file="{ file }">
                            <div>
                                <img
                                    v-if="['jpg','jpeg','png','bmp'].includes((file.ext || '').toLowerCase())"
                                    class="el-upload-list__item-thumbnail"
                                    :src="file.url"
                                    alt=""
                                />
                                <div v-else class="attachments-file-text">
                                    <span>{{ file.name }}</span>
                                </div>
                                <span class="el-upload-list__item-actions">
                                    <span
                                        class="el-upload-list__item-preview"
                                        @click="handleAttachmentPreview(file)"
                                        title="预览"
                                    >
                                        <el-icon>
                                            <ZoomIn />
                                        </el-icon>
                                    </span>
                                    <span
                                        class="el-upload-list__item-delete"
                                        @click="handleAttachmentDownload(file)"
                                        title="下载"
                                    >
                                        <el-icon>
                                            <Download />
                                        </el-icon>
                                    </span>
                                    <span
                                        v-if="!isView"
                                        class="el-upload-list__item-delete"
                                        @click="handleAttachmentRemove(file)"
                                        title="删除"
                                    >
                                        <el-icon>
                                            <Delete />
                                        </el-icon>
                                    </span>
                                </span>
                            </div>
                        </template>
                    </el-upload>
                    <el-empty v-if="!fileList.length && !forms.billCode" description="暂无附件，待申请单号生成后可上传" />
                </div>
            </el-tab-pane>

        </el-tabs>

        <div style="text-align:left; margin-top: 20px;">
            <el-button type="primary" icon="Select" @click="submit" v-if="!isView">保存</el-button>
            <el-button icon="Back" @click="back">返回</el-button>
        </div>

        <div style="margin-top: 15px;">
            <el-card>
                <template #header>
                    <div style="display:flex;align-items:center;justify-content:space-between;">
                        <div>采购申请单明细</div>
                        <div>
                            <el-button plain icon="Plus" type="primary" size="small" @click="addDetail" v-if="!isView">
                                新增明细
                            </el-button>

                            <el-dropdown v-if="!isView" style="margin:0px 10px;" size="small">
                                <el-button plain icon="Upload" type="primary" size="small">
                                    数据操作
                                </el-button>
                                <template #dropdown>
                                    <el-dropdown-menu>
                                        <el-dropdown-item>导入明细</el-dropdown-item>
                                        <el-dropdown-item>下载模板</el-dropdown-item>
                                    </el-dropdown-menu>
                                </template>
                            </el-dropdown>
                        </div>
                    </div>
                </template>

                <el-table ref="detailTable" :data="details" stripe border style="width: 100%">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column type="index" label="行号" width="55"></el-table-column>
                    <el-table-column prop="detailImg" label="图片" width="60">
                        <template v-slot="scope">
                            <el-image style="height: 32px; width: 32px" lazy
                                :src="apiUrl + 'static/code/' + scope.row.detailCode + '?t=0'"
                                :preview-src-list="[apiUrl + 'static/code/' + scope.row.detailCode + '?t=1']">
                                <template #error><img style="width: 100%" src="~@/assets/imgunfine.jpg"
                                        alt="" /></template>
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="productCode" label="货品信息" width="160">
                        <template #default="{ row }">
                            <el-autocomplete v-model="row.productSearchText"
                                :fetch-suggestions="(queryString, cb) => searchProductAsync(queryString, cb, row)"
                                placeholder="输入货品编号/名称/条码搜索" :disabled="isEdit || isView"
                                @select="(item) => handleProductSelect(item, row)" size="small" style="width:100%"
                                :trigger-on-focus="false" :debounce="300">
                                <template #default="{ item }">
                                    <div style="display: flex; justify-content: space-between;">
                                        <span style="font-weight: bold;">{{ item.detailCode }}</span>
                                        <span style="">{{ item.serialCode }}</span>
                                        <span style="color: #8492a6; font-size: 12px;">{{ item.detailName }}</span>
                                    </div>
                                </template>
                            </el-autocomplete>
                        </template>
                    </el-table-column>
                    <el-table-column prop="productCode" label="货品款号" width="110">
                        <template #default="{ row }">
                            <el-text size="small">{{ row.productCode }}</el-text>
                        </template>
                    </el-table-column>
                    <el-table-column prop="productName" label="货品名称" width="250">
                        <template #default="{ row }">
                            <el-input v-model="row.productName" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="unitName" label="单位" width="90">
                        <template #default="{ row }">
                            <el-input v-model="row.unitName" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="productSpec" label="规格" width="130">
                        <template #default="{ row }">
                            <el-input v-model="row.productSpec" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="brandCode" label="品牌" width="130">
                        <template #default="{ row }">
                            <el-select v-model="row.brandCode" filterable clearable placeholder="品牌" :disabled="isView" style="width:100%" size="small">
                                <el-option v-for="b in brands" :key="b.id" :label="b.brandName || b.BrandName" :value="b.brandCode || b.BrandCode"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>

                    <el-table-column prop="suggestSupplierCode" label="供货工厂" width="130">
                        <template #default="{ row }">
                            <el-select v-model="row.suggestSupplierCode" filterable clearable placeholder="供应商"
                                :disabled="isView" style="width:100%" size="small" @change="(value) => {
                                    const selected = suppliers.find(s => s.supplierCode === value);
                                    row.suggestSupplierName = selected ? selected.supplierName : '';
                                }">
                                <el-option v-for="s in suppliers" :key="s.supplierCode"
                                    :label="s.supplierName || s.text" :value="s.supplierCode"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="supplierProductCode" label="工厂款号" width="110">
                        <template #default="{ row }">
                            <el-input v-model="row.supplierProductCode" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="requiredQuantity" label="需求数量" width="140">
                        <template #default="{ row }">
                            <el-input-number v-model="row.requiredQuantity" size="small" :disabled="isView"
                                @change="onQuantityOrPriceChange(row)" :precision="2" :min="0"
                                style="width:100%"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="estimatedPrice" label="预估单价" width="140">
                        <template #default="{ row }">
                            <el-input-number v-model="row.estimatedPrice" size="small" :disabled="isView"
                                @change="onQuantityOrPriceChange(row)" :precision="2" :min="0"
                                style="width:100%"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="estimatedAmount" label="预估金额" width="90">
                        <template #default="{ row }">
                            <span>{{ row.estimatedAmount || 0 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="requiredDate" label="要求到货" width="130">
                        <template #default="{ row }">
                            <el-date-picker v-model="row.requiredDate" type="date" size="small" :disabled="isView"
                                format="YYYY-MM-DD" style="width:100%"></el-date-picker>
                        </template>
                    </el-table-column>
                    <el-table-column prop="stampText" label="字印" width="160">
                        <template #default="{ row }">
                            <el-input v-model="row.stampText" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" width="200">
                        <template #default="{ row }">
                            <el-input v-model="row.remark" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="100" fixed="right">
                        <template #default="{ row, $index }">
                            <el-button @click="deleteDetailRow($index)" link size="small" type="danger"
                                v-if="!isView">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </div>

    </el-card>
</template>

<script>
import { fetchBillCode, fetchPurchaseSupplier, fetchPurchaseBrand } from '@/api/purchase'
import { searchSkuList } from '@/api/product'
import { fetchFileList, delFile } from '@/api/basic'
import { Plus, ZoomIn, Download, Delete } from '@element-plus/icons-vue'

export default {
    name: 'PurchaseRequisitionBill',
    components: {
        Plus,
        ZoomIn,
        Download,
        Delete
    },
    data() {
        return {
            apiUrl: '',
            activeTab: 'basic',
            companys: [],
            departments: [],
            suppliers: [],
            brands: [],
            fileList: [],

            details: [],
            forms: {
                billDate: new Date(),
                status: 0,
                totalQuantity: 0,
                totalAmount: 0,
                companyID: '',
                companyName: '',
                departmentID: '',
                departmentName: '',
                billCode: '',
                billType: '',
                externalNo: '',
                suggestSupplierCode: '',
                suggestSupplierName: ''
            },
            // 表单校验规则
            rules: {
                billCode: [
                    { required: true, message: '申请单号不能为空', trigger: 'blur' }
                ],
                billType: [
                    { required: true, message: '请选择单据类型', trigger: 'change' }
                ],
                billDate: [
                    { required: true, message: '请选择制单日期', trigger: 'change' }
                ],
                companyID: [
                    { required: true, message: '请选择所属公司', trigger: 'change' }
                ],
                departmentID: [
                    { required: true, message: '请选择申请部门', trigger: 'change' }
                ],
                applicantName: [
                    { required: true, message: '请输入申请人', trigger: 'blur' },
                    { min: 2, max: 50, message: '申请人长度在 2 到 50 个字符', trigger: 'blur' }
                ],
                requirementDate: [
                    { required: true, message: '请选择需求日期', trigger: 'change' }
                ]
            },
        }
    },
    computed: {
        isEdit() { return this.$route.query.id && this.$route.query.mode !== 'view' },
        isView() { return this.$route.query.mode === 'view' },
        requisitionId() { return this.$route.query.id },
        uploadAction() {
            const code = this.forms.billCode || ''
            return `${this.apiUrl}BaseUploader/Basic?dataType=PurchaseRequisition&dataID=${code}&fileType=form&fileCode=${code}`
        }
    },
    mounted() {
        this.apiUrl = process.env.VUE_APP_BASEURL;
        this.$kaung.init(this.$options.name);

        this.$kaung.companys().then((res) => {
            this.companys = res;
            this.companyChange();
        });

        fetchPurchaseSupplier().then((res) => {
            if (res && res.code === 200) {
                this.suppliers = Array.isArray(res.data) ? res.data : []
            }
        });

        // 加载品牌列表
        fetchPurchaseBrand().then((res) => {
            if (res && res.code === 200) {
                this.brands = Array.isArray(res.data) ? res.data : []
            }
        });

        if (this.requisitionId) {
            this.load();
        } else {
            fetchBillCode(this.$options.name).then(res => {
                this.forms.billCode = res.data || '';
                this.forms.billType = '常规采购';
                this.forms.applicantName = this.$store.getters.getUserInfo.realName || this.$store.getters.getUserInfo.userName || '';
                //console.log('getUserInfo', this.$store.getters.getUserInfo)
                this.forms.companyID = this.$store.getters.getUserInfo.companyID || '';
                this.forms.departmentID = this.$store.getters.getUserInfo.departmentID || ''
                this.companyChange(this.forms.departmentID);
                this.loadAttachments();
            })
        }
    },
    methods: {
        // 搜索货品信息
        searchProductAsync(queryString, callback, row) {
            if (!queryString || queryString.trim().length < 2) {
                callback([]);
                return;
            }

            searchSkuList(queryString).then(res => {
                if (res && res.data && res.data.data) {
                    const suggestions = res.data.data;
                    callback(suggestions);
                } else {
                    callback([]);
                }
            }).catch(err => {
                console.error('Product search error:', err);
                callback([]);
            });
        },
        // 选择货品后填充信息
        handleProductSelect(item, row) {
            if (!item) return;

            row.productId = item.id || '';
            row.productCode = item.serialCode || item.brandModelCode || item.factoryModelCode || '';
            row.productName = item.detailName || '';
            row.productSpec = item.detailUnit || '';
            row.productBarcode = item.brandModelCode || item.factoryModelCode || item.serialCode || '';
            row.unitName = item.unitName || '';
            row.detailId = item.id || '';
            row.detailCode = item.detailCode || '';
            row.detailName = item.detailName || '';

            // 设置搜索文本为货品编号，便于显示和编辑
            row.productSearchText = item.detailCode || item.serialCode || item.brandModelCode || item.factoryModelCode || '';

            row.suggestSupplierCode = item.factoryCode || '';
            row.suggestSupplierName = item.factoryName || '';
            row.supplierProductCode = item.factoryModelCode || '';

            // 如果已设置订货数量，触发重新计算
            if (row.orderQuantity > 0) {
                this.onDetailChange(row);
            }

            this.$message.success('货品信息已填充');
        },
        load() {
            this.$kaung.getone(this.requisitionId).then(res => {
                if (res.code === 200) {
                    this.forms = { ...res.data };
                    this.companyChange(this.forms.departmentID);
                    this.loadAttachments();
                }
            });

            this.fetchDetails();
        },
        fetchDetails() {
            this.$kaung.fetch({ url: 'PurchaseRequisitionDetail/GetDetailList', params: { billId: this.requisitionId }, method: 'get' })
                .then(res => {
                    if (res && res.code === 200) {
                        this.details = res.data;
                        this.details.forEach(detail => {
                            detail.productSearchText = detail.detailCode;
                        });
                    }
                })
        },
        // 同步附件列表，确保文件与申请单号绑定
        loadAttachments() {
            const billCode = this.forms.billCode
            if (!billCode) {
                this.fileList = []
                return
            }

            fetchFileList(billCode).then(res => {
                if (res && res.code === 200) {
                    this.fileList = Array.isArray(res.data) ? res.data : []
                }
            })
        },
        handleAttachmentBeforeUpload() {
            if (!this.forms.billCode) {
                this.$message.warning('请先生成申请单号后再上传附件')
                return false
            }
            return true
        },
        handleAttachmentUploadSuccess(res) {
            if (res && res.code === 200) {
                this.$message.success(res.content || '上传成功')
                this.loadAttachments()
            } else {
                this.$message.error(res?.content || '上传失败')
            }
        },
        handleAttachmentPreview(file) {
            if (file && file.id) {
                window.open('/preview?id=' + file.id)
            } else if (file && file.url) {
                window.open(file.url)
            }
        },
        handleAttachmentDownload(file) {
            if (file && file.url) {
                window.open(file.url)
            }
        },
        handleAttachmentRemove(file) {
            if (!file || !file.id) {
                return
            }

            this.$confirm('确定要删除该附件吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                delFile(file.id).then(res => {
                    if (res && res.code === 200) {
                        this.$message.success(res.content || '删除成功')
                        this.loadAttachments()
                    } else {
                        this.$message.error(res?.content || '删除失败')
                    }
                })
            }).catch(() => { })
        },
        addDetail() {
            const newDetail = {
                id: null,
                billId: this.requisitionId || '',
                productCode: '',
                productName: '',
                unitName: '',
                requiredQuantity: 0,
                estimatedPrice: 0,
                estimatedAmount: 0,
                requiredDate: null,
                remark: '',
                stampText: '',
                _isNew: true
            }

            this.details.push(newDetail)
        },
        editDetail(row) {
            const detailId = row && row.id ? row.id : 'add'
            this.$router.push({ name: 'PurchaseRequisitionDetail', query: { id: this.requisitionId, detail: detailId } })
        },

        submit() {
            // 首先验证表单
            this.$refs.forms.validate((valid) => {
                if (!valid) {
                    this.$message.error('请完善必填信息');
                    return false;
                }

                // 验证明细数据
                if (!this.details || this.details.length === 0) {
                    this.$message.error('请至少添加一条采购明细');
                    return false;
                }

                // 验证明细必填字段
                for (let i = 0; i < this.details.length; i++) {
                    const detail = this.details[i];
                    if (!detail.productCode || !detail.productName) {
                        this.$message.error(`第 ${i + 1} 行：货品编号和货品名称不能为空`);
                        return false;
                    }
                    if (!detail.requiredQuantity || detail.requiredQuantity <= 0) {
                        this.$message.error(`第 ${i + 1} 行：需求数量必须大于0`);
                        return false;
                    }
                }

                // 提交数据
                this.$kaung.post({ url: '/' + this.$options.name + '/PostForms', data: { master: this.forms, details: this.details } }).then(res => {
                    if (res.code === 200) {
                        this.$message({ message: res.content, type: res.type });
                        this.back();
                    }
                }).catch(err => {
                    this.$message.error('提交失败：' + (err.message || '未知错误'));
                });
            });
        },
        back() { this.$router.back() },

        companyChange(departmentID) {
            this.forms.departmentID = departmentID || '';
            this.departments = [];
            var that = this;
            if (this.forms.companyID) {
                this.$kaung.departments(this.forms.companyID).then((res) => {
                    that.departments = res;
                });
            }
        },

        onQuantityOrPriceChange(row) {
            const quantity = Number(row.requiredQuantity) || 0
            const price = Number(row.estimatedPrice) || 0
            row.estimatedAmount = (quantity * price).toFixed(2)
        },

        deleteDetailRow(index) {
            this.$confirm('确定要删除该明细行吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.details.splice(index, 1)
                this.$message({ type: 'success', message: '已删除' })
            }).catch(() => { })
        }
    }
}
</script>

<style scoped>
.attachments-pane {
    padding: 10px 0 0 10px;
}

.attachments-alert {
    margin-bottom: 12px;
}

.attachments-file-text {
    font-size: 12px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    text-align: center;
    overflow-wrap: anywhere;
}

.attachments-pane :deep(.el-upload-list--picture-card .el-upload-list__item),
.attachments-pane :deep(.el-upload--picture-card) {
    width: 100px;
    height: 100px;
}

.attachments-pane :deep(.el-upload-list--picture-card .el-upload-list__item-thumbnail) {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.attachments-pane :deep(.el-upload-list__item-actions span + span) {
    margin-left: 4px;
}
</style>